import { graphql } from 'app/generated/gql'
import type { Client } from '@urql/core'

import type { AppointmentType as AppointmentTypeType, AppointmentTypeListResult } from 'app/generated/graphql'
import { EntityStore } from './EntityStore'

const LIST_QUERY = graphql(`
  query AppointmentTypes($search: String, $pagination: PaginationInput, $sort: SortInput, $locationId: ID!) {
    appointmentTypes(search: $search, pagination: $pagination, sort: $sort, locationId: $locationId) {
      hits {
        activeAgent
        activeScheduler
        alias
        appointmentLength
        blockScheduling
        blockSchedulingNotes
        createdDate
        displayName
        doubleBookingExclusion
        excludedBlockouts
        generalBuffer
        id
        kollaConsumerId
        morningBuffer
        morningBufferLookahead
        name
        order
        orgId
        patientType
        procedureCodes
        startIncrement
        updatedDate
        vendor
        vendorId
        version
        workspaceId
      }
      total
      page
    }
  }
`)

const UPDATE_MUTATION = graphql(`
  mutation UpdateAppointmentTypeStore($id: ID!, $input: UpdateAppointmentTypeInput!) {
    updateAppointmentType(id: $id, input: $input) {
      activeAgent
      activeScheduler
      alias
      appointmentLength
      blockScheduling
      blockSchedulingNotes
      createdDate
      displayName
      doubleBookingExclusion
      excludedBlockouts
      generalBuffer
      id
      kollaConsumerId
      morningBuffer
      morningBufferLookahead
      name
      order
      orgId
      patientType
      procedureCodes
      startIncrement
      updatedDate
      vendor
      vendorId
      version
      workspaceId
    }
  }
`)

export class AppointmentTypeStore extends EntityStore<
  AppointmentTypeType,
  AppointmentTypeListResult,
  undefined,
  typeof UPDATE_MUTATION
> {
  constructor(client: Client) {
    super(client, {
      listQuery: LIST_QUERY,
      updateMutation: UPDATE_MUTATION,
      extractList: (data: any) => data.appointmentTypes,
      extractOne: (data: any) => data.appointmentType,
      extractMutated: (data: any) => data.updateAppointmentType,
    })
  }
}
